<template lang="html">
  <div class="admin-statistics-wrapper">
    <div class="upper">
      <div class="section">
        <div class="title">
          POSTOJI UKUPNO
        </div>
        <div class="values-wrapper">
          <div class="single-value">
            <span class="value">{{ general.legal }}</span>
            <span class="label">Pravnih lica</span>
          </div>
          <div class="single-value">
            <span class="value">{{ general.non_legal }}</span>
            <span class="label">Fizičkih lica</span>
          </div>
          <div class="single-value">
            <span class="value">{{ general.categories }}</span>
            <span class="label">Kategorije</span>
          </div>
          <div class="single-value">
            <span class="value">{{ general.newsletter }}</span>
            <span class="label">Newsletter</span>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="title">
          U IZABRANOM PERIODU
        </div>
        <div class="values-wrapper">
          <div class="single-value">
            <span class="value">{{ generalPeriod.new_product }}</span>
            <span class="label">Novih objava</span>
          </div>
          <div class="single-value">
            <span class="value">{{ generalPeriod.offers }}</span>
            <span class="label">Ponuda</span>
          </div>
          <div class="single-value">
            <span class="value">{{ generalPeriod.created_users }}</span>
            <span class="label">Novih korisnika</span>
          </div>
          <div class="single-value">
            <span class="value">{{ generalPeriod.canceled_offers }}</span>
            <span class="label">Odustajanja</span>
          </div>
        </div>
      </div>
    </div>
    <div class="lower">
      <div class="title">
        STATISTIKA RADA
      </div>
      <div class="time-wrapper">
        <input type="date" v-model="dateFrom" />
        <span>-</span>
        <input type="date" v-model="dateTo" />
      </div>
      <div class="stats-wrapper">
        <!-- bought out -->
        <div class="stats">
          <div class="stats-title">
            Rasprodata dobra
          </div>
          <div class="data">
            <div v-if="boughtOut.length > 0" class="">
              <div
                v-for="(data, index) in boughtOut"
                :key="index"
                class="single-data"
              >
                <div :title="data.pro_name" class="label">
                  {{ data.pro_name }}
                </div>
                <!-- <div class="value">
                  {{data.value}}
                </div> -->
              </div>
            </div>
            <div v-else class="">
              /
            </div>
          </div>
        </div>
        <!-- most bought -->
        <div class="stats">
          <div class="stats-title">
            Najprodavanije
          </div>
          <div class="data">
            <div v-if="mostBought.length > 0" class="">
              <div
                v-for="(data, index) in mostBought"
                :key="index"
                class="single-data"
              >
                <div :title="data.pro_name" class="label">
                  {{ data.pro_name }}
                </div>
                <div class="value">
                  {{ data.offer_count }}
                </div>
              </div>
            </div>
            <div v-else class="">
              /
            </div>
          </div>
        </div>
        <!-- expired -->
        <div class="stats">
          <div class="stats-title">
            Istekli oglasi
          </div>
          <div class="data">
            <div v-if="expired.length > 0" class="">
              <div
                v-for="(data, index) in expired"
                :key="index"
                class="single-data"
              >
                <div :title="data.pro_name" class="label">
                  {{ data.pro_name }}
                </div>
                <div class="value">
                  {{ $moment(data.pro_expiry).format('YYYY-MM-DD') }}
                </div>
              </div>
            </div>
            <div v-else class="">
              /
            </div>
          </div>
        </div>
        <!-- popular -->
        <div class="stats">
          <div class="stats-title">
            Najpregledaniji oglasi
          </div>
          <div class="data">
            <div v-if="popular.length > 0" class="">
              <div
                v-for="(data, index) in popular"
                :key="index"
                class="single-data"
              >
                <div :title="data.pro_name" class="label">
                  {{ data.pro_name }}
                </div>
                <div class="value">
                  {{ data.sts_count }}
                </div>
              </div>
            </div>
            <div v-else class="">
              /
            </div>
          </div>
        </div>
        <!-- popular -->
        <div class="stats">
          <div class="stats-title">
            Najpopularnije kategorije
          </div>
          <div class="data">
            <div v-if="categories.length > 0" class="">
              <div
                v-for="(data, index) in categories"
                :key="index"
                class="single-data"
              >
                <div :title="data.cat_name" class="label">
                  {{ data.cat_name }}
                </div>
                <div class="value">
                  {{ data.sts_count }}
                </div>
              </div>
            </div>
            <div v-else class="">
              /
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
export default {
  name: 'adminStatistics',
  data () {
    return {
      dateFrom: null,
      dateTo: null,
      boughtOut: [],
      mostBought: [],
      expired: [],
      popular: [],
      categories: [],
      general: {},
      generalPeriod: {}
    }
  },
  mounted () {
    this.setDates()
    this.getStats()
  },
  methods: {
    getStats () {
      console.log(this.dateFrom, this.dateTo)
      let params = {
        start_date: this.dateFrom,
        end_date: this.dateTo + ' 23:59:59'
      }
      api.getBoughtOut(params).then(res => {
        this.boughtOut = res.data.data
      })
      api.getMostBought(params).then(res => {
        this.mostBought = res.data.data
      })
      api.getExpired(params).then(res => {
        this.expired = res.data.data
      })
      api.getStatisticGeneral(params).then(res => {
        this.general = res.data
      })
      api.getStatisticGeneralPeriod(params).then(res => {
        this.generalPeriod = res.data
      })
      api.getPopularStatistics(params).then(res => {
        this.popular = res.data.data
      })
      api.getCategoriesStatistics(params).then(res => {
        this.categories = res.data.data
      })
    },
    setDates () {
      this.dateFrom = this.$moment()
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
      this.dateTo = this.$moment().format('YYYY-MM-DD')
    }
  },
  watch: {
    dateFrom: {
      handler: function () {
        this.getStats()
      }
    },
    dateTo: {
      handler: function () {
        this.getStats()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-statistics-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';

  .title {
    margin-bottom: 25px;
    // font-weight: bold;
    font-size: 21px;
    color: $text-color;
  }
  .upper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .section:first-child {
      margin-right: 40px;
    }
    .section {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 40px;

      .values-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .single-value {
          margin-right: 10px;
          height: 125px;
          min-width: 125px;
          padding: 5px;
          box-sizing: border-box;
          box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .value {
            font-weight: bold;
            font-size: 40px;
            line-height: 46px;
            letter-spacing: 0.03em;
            color: #aeaeae;
            margin-bottom: 5px;
          }
          .label {
            font-weight: 600;
            font-size: 13px;
            line-height: 21px;
            letter-spacing: 0.06em;
            color: #787878;
          }
        }
      }
    }
  }
  .lower {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .time-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;

      * {
        margin-right: 10px;
      }
    }
    .stats-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .stats {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border: 1px solid rgba(243, 243, 243, 0.7);
        box-sizing: border-box;
        box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.03);
        margin-right: 45px;
        width: 370px;
        padding: 20px 10px;
        margin-bottom: 10px;

        .stats-title {
          font-weight: 800;
          font-size: 13px;
          line-height: 21px;
          letter-spacing: 0.06em;
          color: rgba(160, 160, 160, 0.9);
          margin-bottom: 20px;
          text-transform: uppercase;
          padding-left: 10px;
        }
        .data {
          width: 100%;
          display: flex;
          flex-direction: column;

          .single-data {
            width: 100%;
            height: 50px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;
            box-sizing: border-box;
            color: #606060;
            letter-spacing: 0.06em;

            .label {
              font-size: 15px;
              height: 100%;
              overflow: hidden;
              text-align: left;
              max-width: 200px;
              line-height: 50px;
              text-overflow: ellipsis;
            }
            .value {
              font-weight: bold;
              font-size: 15px;
            }
          }
          .single-data:nth-child(odd) {
            background: rgba(196, 196, 196, 0.15);
          }
        }
      }
    }
  }
}
</style>
